import {createFileRoute} from '@tanstack/react-router';

import DiagnosticReportRequest from '@/practitioner/views/diagnosticReport/DiagnosticReportRequest';

export const Route = createFileRoute('/(practitioner)/practitioner/diagnostic-report-request')({
  component: DiagnosticReportRequest
});
